'use client';

import { useEffect } from 'react';

import {
  removeSafeLocalStorageItem,
  setSafeLocalStorageItem,
} from '@utils/localStorage/getSafeLocalStorage';

type Props = {
  loyaltyUserInfo: string | undefined;
};

const SaveLoyaltyUserToLocalStorage = ({ loyaltyUserInfo }: Props) => {
  useEffect(() => {
    if (loyaltyUserInfo) {
      setSafeLocalStorageItem('loyaltyUserInfo', loyaltyUserInfo);
    } else {
      removeSafeLocalStorageItem('loyaltyUserInfo');
    }
  }, [loyaltyUserInfo]);
  return null;
};

export default SaveLoyaltyUserToLocalStorage;
